import React from 'react';
import PropTypes from 'prop-types';
import { Row, Panel, Col } from 'react-bootstrap';
import * as consts from '../../const.js';
import { generateIteratorKey as keygen } from '../../utils/helpers';
import Link from 'react-router-dom/Link';
import { peopleDetails_studyFlow } from '../../constants/localUrls';
import { Time } from 'tc-client-common';

const columns = {
  user: consts.DL_COLUMN_USER,
  assigned: consts.DL_COLUMN_ASSIGNED,
  organization: consts.DL_COLUMN_SITE,
  country: consts.DL_COLUMN_COUNTRY,
  actions: consts.ACTIONS
};

class DelegationLogRow extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { models, study } = this.props,
      entries = [],
      org = models[0].user.hiredOrganization.organisation.name;
    for (let model of models) {
      const type = model.organisation.organizationType;
      const isForAllSites = model.organisation.id === 0 || (type && type.toLowerCase() === 'sponsor');
      const orgType = isForAllSites ? '' : model.organisation.organizationType;
      let orgName =
        model.organisation.name == null || isForAllSites ? consts.DELEGATION_LOG_ALL_SITES : model.organisation.name;
      let siteTypeCap = orgType.slice(0, 1) + orgType.toLowerCase().slice(1);
      if (type === consts.IRB_TYPE) {
        orgName = consts.NA_ORG_NAME;
        siteTypeCap = consts.ONLY_DOCUMENTS_ASSIGNED;
      }
      let orgCountry = consts.EMPTY_COUNTRY;
      if (isForAllSites) {
        orgCountry = consts.DELEGATION_LOG_ALL_COUNTRIES;
      } else if (model.organisation.country) {
        orgCountry = model.organisation.country;
      }
      const roleName = model.userRole.name;
      const roleNameCap = roleName.slice(0, 1) + roleName.toLowerCase().slice(1).split('_').join(' ');

      const link = (
        <Link
          className="link"
          to={{
            pathname: peopleDetails_studyFlow(study.gid, model.user.userId),
            state: {
              user: model.user,
              studyGid: study.gid,
              studyName: study.name,
              forBreadcrumb: {
                ...model.user,
                studyGid: study.gid,
                studyName: study.name
              }
            }
          }}
        >
          View
        </Link>
      );

      const entry = (
        <Row {...keygen()}>
          <Col className="delegation-log-col" sm={4} lg={4}>
            <div className="fullName">
              {model.user.firstName} {model.user.lastName}
            </div>
            <div className="roleName">{roleNameCap}</div>
            <div className="email">{model.user.username}</div>
          </Col>
          <Col className="delegation-log-col" sm={3} lg={3}>
            <div>
              <Time timezone={model.organisation.timezone} timestamp={model.updatedAt} format={'DD MMM YYYY'} />{' '}
            </div>
            <div className="details">
              <Time timezone={model.organisation.timezone} timestamp={model.updatedAt} format={'hh:mm A'} offset />
            </div>
          </Col>
          <Col className="delegation-log-col" sm={4} lg={4}>
            <div className="siteName">{orgName}</div>
            <div className="siteType">{siteTypeCap}</div>
            <div className="country">{orgCountry}</div>
          </Col>
          <Col className="delegation-log-col" sm={1} lg={1}>
            {link}
          </Col>
        </Row>
      );

      entries.push(entry);
    }

    return (
      <Panel eventKey={this.props.eventKey} {...keygen()}>
        <Panel.Heading>
          <Panel.Title toggle>
            <div className="delegation-log-heading">
              <span className="delegation-log-hired-org">{org}</span>
              <i className="material-icons collapse-icon">expand_less</i>
              <i className="material-icons expand-icon">expand_more</i>
            </div>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible>
          <div className={`delegation-row-body`}>
            <Row {...keygen()}>
              <Col className="delegation-log-col" sm={4} lg={4}>
                {columns.user}
              </Col>
              <Col className="delegation-log-col" sm={3} lg={3}>
                {columns.assigned}
              </Col>
              <Col className="delegation-log-col" sm={4} lg={4}>
                {columns.organization}
              </Col>
              <Col className="delegation-log-col" sm={1} lg={1}>
                {columns.actions}
              </Col>
            </Row>
            {entries}
          </div>
        </Panel.Body>
      </Panel>
    );
  }
}

DelegationLogRow.propTypes = {
  /* study is needed to set breadcrumb state on view personnel link*/
  study: PropTypes.object.isRequired,
  models: PropTypes.array,
  eventKey: PropTypes.number
};

export default DelegationLogRow;
